import { createElement } from 'react';
import BannersSlider from '@sb/sb-banners';
import { render } from '../../libs/ngsModuleLoader';

import Translator from '../Translator';
import deviceDetector from '../DeviceDetector';

const NEW_BANNERS_CONTAINERS = {
    homepage: 'newBannersHomepageContainer',
    event: 'newBannersEventPageContainer',
    highlights: 'newBannersHighlightsPageContainer',
};

const getPlatform = () => {
    let platform = deviceDetector.getDeviceType();
    if(deviceDetector.isTablet()) {
        platform = 'mobile';
    }
    if(deviceDetector.isNativeAndroid()) {
        platform = 'android';
    }
    if(deviceDetector.isNativeiOS()) {
        platform = 'ios';
    }
    return platform;
};

const getEventId = type => type === 'event' ? window.WH.sportsbook.eventId : 'default';
const getSportName = type => type === 'event' ? 'sport' : window.WH.sportsbook.sport;
const getDomain = () => window.whStatic.config.fragmentCdnHost;
const getJurisdiction = () => window.whStatic.config.jurisdiction.toLowerCase().replace('.', '');
const getConsole = () => window.consoleReference || window.console;

const getDataUrl = (type, locale, segment) => {
    const dataFileName = `${getSportName(type)}-${getEventId(type)}-${getPlatform()}-${segment}.json`;

    return `${getDomain()}/dynamic-data/banners-service/${getJurisdiction()}/${locale}/${dataFileName}`;
};

export const renderNewBanners = (type) => {
    const container = document.getElementById(NEW_BANNERS_CONTAINERS[type]);
    if(!container) {
        getConsole().warn('No container for new banners');
        return;
    }

    const locale = Translator.getLocale() || 'en-gb';
    const dataUrl = getDataUrl(type, locale, 'all');

    render(container, { uiKit: true }, ({ device, navigate }) => {
        return createElement(BannersSlider, { dataUrl, device, navigate }, null);
    });
};
